import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import hi from './hi.json';
import te from './te.json';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hi: { translation: hi }, te: { translation: te } },
  lng: localStorage.getItem('bp-lang') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export const setLanguage = (lang) => {
  localStorage.setItem('bp-lang', lang);
  i18n.changeLanguage(lang);
};

/** Pick the localized name off a category row (name_en / name_hi / name_te) */
export const categoryName = (cat) => cat[`name_${i18n.language}`] || cat.name_en;

export default i18n;
